import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppversionService {

  private baseUrl = environment.baseUrl + 'ApplicationInformation';
  
  constructor(private http: HttpClient) {
  }
  getApplicationVersion(): Observable<any> {
    return this.http.get(`${this.baseUrl}/getApplicationInformation`);
  }
}
